import * as httpClient from '../utils/httpClient';
import { queryStringBuilder } from '../utils/requestHelpers';
import { logger } from '../utils/logger';
import { asArray } from '../utils';
import { getDefaultI18Service } from '../tppServices/tppDi';
import { locationLanguage } from '../tppServices/translations/languageConstants';

const suggestionLocales = (locale) => {
  if (locale === 'dk') {
    return 'da';
  }
  const acceptedLocales =  [ 'es', 'de', 'fr', 'it', 'nl', 'da',  'no', 'se', 'fi' ];
  if (acceptedLocales.includes(locale)) {
    return locale;
  }
  return null;
};

const suggestionLocationPath = (location, locale) => {
  return queryStringBuilder(`/location/suggestions`)
  .addParam('location', location)
  .addParam('language', suggestionLocales(locale))
  .join();
};

const getSuggestionName = (suggestion) => {
  if (!suggestion.Place.Text) {
    return suggestion.Place.Country;
  }

  const textParts = suggestion.Place.Text.split(',');
  const firstPart = textParts[0].trim();

  if (/^[A-Z]{2}$/.test(firstPart)) {
    try {
      const i18Service = getDefaultI18Service();
      const formatMessage = i18Service.getCurrentI18n().intl.formatMessage;
      const translationKey = `app.countrySubdivision.US-${firstPart}`;
      const translation = formatMessage({ id: translationKey });

      if (translation) {
        textParts[0] = translation;
      }
    } catch (error) {
      return `${textParts.join(', ')}, ${suggestion.Place.Country}`;
    }
  }
  return `${textParts.join(', ')}, ${suggestion.Place.Country}`;
};

export const getSuggestionsLocations = async (location, locale, requestContext) => {
  let names = [];
  let locationIds = [];
  try {
    const apiClient = httpClient.getHttpClient(requestContext?.headers);
    const suggestedLocations = suggestionLocationPath(location, locale);
    const suggestedResponse = await apiClient.get(suggestedLocations);
    const suggestions = asArray(suggestedResponse?.data?.Results);
    for (const suggestion of suggestions) {
      const name = getSuggestionName(suggestion);
      names.push(name);
      locationIds.push({ id: suggestion.Place?.PlaceId, name });
    }
    return { names, locationIds, error: null };
  } catch (err) {
    // eslint-disable-next-line no-console
    logger.error('Error fetching location suggestions:', err);
    return { names, locationIds, error: err };
  }
};


export const getCoordsFromLocationId = async (locationId, requestContext, locale = 'en') => {
  try {
    const language = locationLanguage(locale);
    const locationEndpoint = `/location/place?placeId=${locationId}&language=${language}`;
    const apiClient = httpClient.getHttpClient(requestContext?.headers);
    const locationResponse = await apiClient.get(locationEndpoint);

    const results = locationResponse?.data?.Results;
    if (results && results.Geometry?.Point && results.Label) {
      const [lon, lat] = results.Geometry.Point;
      const name = results.Label;
      const location = { lat, lon, name };
      return { location, error: null };
    }
    if (results && results.Geometry?.Point) {
      const [lon, lat] = results.Geometry.Point;
      const location = { lat, lon, name: null };
      return { location, error: null };
    }
    return { location: null, error: new Error('Invalid location data received') };
  } catch (err) {
    logger.error('Error fetching coords from  getCoordsFromLocationId:', err);
    return { location: null, error: err };
  }
};
